import { Component, OnInit, AfterViewInit, Inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import {Observable} from 'rxjs/Observable';
declare var $: any;
//services
import {StoreService} from 'src/app/services/store.service';
import {SharedService} from 'src/app/services/shared.service';
import {SEOService} from 'src/app/services/seo.service';
import {AnalyticsService} from 'src/app/services/analytics.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, AfterViewInit {
  cartData: Observable<any>;
  data: Observable<any>;
  user: Observable<any>;
  totalItem: number;
  schedule: Observable<any>;
  selected_policy: any;
  
  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: any,
    public router: Router,
    private storeService: StoreService,
    private seoService: SEOService,
    private analyticsService: AnalyticsService
  ) {
    /**RESTORE POLICY IN REDUX STORE UPON REFRESH**/
    this.storeService.storeExistingSelectedPolicy(); // restore existing selected policy
    this.storeService.storeExistingDeliveryTime(); // restore existing delivery time
    this.storeService.setExistingPaymentMethod(); // restore existing delivery time
    this.storeService.storeExistingCartData(); // restore existing cart data
    this.storeService.storeExistingAvailablePromotion(); // restore existing available promotion data
    this.storeService.storeExistingAcceptedPromotion(); // restore existing accepted promotion data
    this.storeService.storeExistingOrderNotes(); // restore existing accepted promotion data
    this.storeService.storeExistingLoginData(); // restore existing accepted promotion data

    this.schedule = this.storeService.schedule;
    this.data = this.storeService.restaurantData;
    this.user = this.storeService.user;

    /**CHECK RESTAURANT INFORMATION IN REDUX STORE THEN, GENERATE RESTAURANT SCHEDULE**/
    this.data.subscribe(result => {
      if (Object.getOwnPropertyNames(result).length !== 0) {
        // this.sharedService.scheduleProcessing();
        const home = result.restaurant_content?.home_page;
          if (home) {
            this.seoService.setPageTitle(home.seo_page_title);
            this.seoService.clearMetaTags();
            this.seoService.addMetaTag(home.seo_meta);
            this.analyticsService.init(home.google_analytics);
            this.analyticsService.createSchema(home.schema);
            
            this.analyticsService.createCustomJavaScript(home.custom_content);
            this.analyticsService.createCustomNoScript(home.custom_no_script);
          }
      }
    });
    /**END**/
  }



  ngOnInit() {
    
  }

  ngAfterViewInit() {
    if (this.platformId === 'browser') {
      $(document).click(function (event: any) {
        var clickover = $(event.target);
        var $navbar = $("#top-menu .navbar-collapse");               
        var _opened = $navbar.hasClass("show");
        if (_opened === true && (clickover.hasClass("nav-link") || clickover.hasClass("btn") || clickover.hasClass("overlay"))) {      
            $navbar.collapse('hide');
            document.body.classList.remove('active-nav');
        }
      });
    }
  }


  bodyFixed() {
    if (this.platformId === 'browser') {
      document.body.classList.toggle('active-nav');
    }
  }
}

